import { Link } from 'react-router-dom'
import { PRODUCT_NAME } from '../pages'
import { PROJECT } from '../project'

/**
 * The footer, matching the one the EVERSE dashboard carries.
 *
 * Attribution and funding acknowledgement belong on every page of a project
 * deliverable, and someone arriving from the main dashboard should recognise
 * where they are.
 */
export function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <span>
          <strong>{PRODUCT_NAME}</strong>, part of{' '}
          <a href={PROJECT.everse.url} target="_blank" rel="noreferrer">
            {PROJECT.everse.name}
          </a>
        </span>
        <span>
          funded by{' '}
          <a href={PROJECT.grant.url} target="_blank" rel="noreferrer">
            {PROJECT.grant.id}
          </a>
        </span>
        <a href={PROJECT.everse.consortiumUrl} target="_blank" rel="noreferrer">
          Consortium
        </a>
        <Link to="/privacy">Privacy and accessibility</Link>
        <a href={PROJECT.sourceUrl} target="_blank" rel="noreferrer" className="footer-icon-link">
          <GitHubMark />
          Source code
        </a>
      </div>
    </footer>
  )
}

function GitHubMark() {
  return (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12 .5C5.65.5.5 5.65.5 12c0 5.08 3.29 9.39 7.86 10.91.58.1.79-.25.79-.55v-1.94c-3.2.7-3.88-1.54-3.88-1.54-.52-1.34-1.28-1.7-1.28-1.7-1.05-.72.08-.7.08-.7 1.16.08 1.77 1.19 1.77 1.19 1.03 1.77 2.71 1.26 3.37.96.1-.75.4-1.26.73-1.55-2.55-.29-5.24-1.28-5.24-5.69 0-1.26.45-2.28 1.19-3.08-.12-.29-.52-1.46.11-3.04 0 0 .97-.31 3.18 1.18a11.07 11.07 0 0 1 5.79 0c2.21-1.49 3.18-1.18 3.18-1.18.63 1.58.23 2.75.11 3.04.74.8 1.19 1.82 1.19 3.08 0 4.42-2.69 5.39-5.25 5.68.41.36.78 1.06.78 2.14v3.18c0 .31.21.66.79.55C20.21 21.38 23.5 17.08 23.5 12 23.5 5.65 18.35.5 12 .5z" />
    </svg>
  )
}
